import { render, staticRenderFns } from "./MealIngredientModifier.vue?vue&type=template&id=a82cf918&scoped=true&"
import script from "./MealIngredientModifier.vue?vue&type=script&lang=js&"
export * from "./MealIngredientModifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a82cf918",
  null
  
)

export default component.exports